module.exports = __webpack_public_path__ + "static/media/community-no-uploads-image.5a091058.svg";